<template>
    <div class="bg-white containBox" style="padding: 16px">
        <div class="content" v-if="typeLastLine.number">
            <p>{{ $t('Order.Details.Components.TraningLineMt.TrackingNo') }}. : {{ typeLastLine.number }}</p>
            <p style="margin-bottom: 10px">{{ $t('Order.Details.Components.TraningLineMt.LastCarrier') }} : {{ typeLastLine.carrier_en }}</p>
            <p>{{ $t('Order.Details.Components.TraningLineMt.ParcelCode') }}：KA202210201112182047_</p>
            <p class="packStatus f--c" :class="{red: packStatus === 'Cancelled ', green: packStatus !== 'Cancelled '}">{{ packStatus }}</p>
            <div v-if="typeLastLine.events.length" class="timeline_line_123123123123213213">
                <el-timeline>
                    <el-timeline-item
                        v-for="(item, index) in typeLastLine.events"
                        :key="index"
                        :type="index === 0 ? 'primary': ''"
                        :timestamp="item.description">
                        <span >{{item.time_iso | timeHandle}}</span>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <emptyShow v-else></emptyShow>
        </div>
        <div class="content" v-if="typeFirstLine.number">
            <h3>{{ $t('Order.Details.Components.TraningLineMt.TrackingNo') }}. : {{ typeFirstLine.number }}</h3>
            <h3 style="margin-bottom: 16px">{{ $t('Order.Details.Components.TraningLineMt.FirstCarrier') }} : {{ typeFirstLine.carrier_en }}</h3>
            <div v-if="typeFirstLine.events.length" class="timeline_line_123123123123213213">
                <el-timeline>
                    <el-timeline-item
                        v-for="(item, index) in typeFirstLine.events"
                        :key="index"
                        :type="index === 0 ? 'primary': ''"
                        :timestamp="item.description">
                        <span >{{item.time_iso | timeHandle}}</span>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <emptyShow v-else></emptyShow>
        </div>
        <emptyShow v-if="!typeLastLine.number && !typeFirstLine.number"></emptyShow>
    </div>
</template>

<script>
import API from '@/api'
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import Step from 'vant/lib/step'
import Steps from 'vant/lib/steps'
import 'vant/lib/step/style'
import 'vant/lib/steps/style'
import dayjs from 'dayjs'
import emptyShow from '@/views/order/list/components/emptyLogistics.vue'

export default {
  components: {
    'van-popup': Popup,
    'van-step': Step,
    'van-steps': Steps,
    emptyShow
  },
  filters: {
    timeHandle(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm')
    }
  },
  data() {
    return {
      trackingNumberVisible: false,
      trackingTimeLine: [],
      trackingNumberInfo: {
        trackingNumber: undefined,
        carrierCode: undefined
      },
      omsPackId: undefined,
      packStatus: '',
      trackingNumber: ''
    }
  },
  computed: {
    // 头程物流
    typeFirstLine() {
      const target = this.trackingTimeLine.find(e => e.type === 1)
      return target || { events: [], status: '' }
    },
    // 尾程物流
    typeLastLine() {
      const target = this.trackingTimeLine.find(e => e.type === 2)
      return target || { events: [], status: '' }
    }
  },
  created() {
    this.omsPackId = this.$route.query.omsPackId
    this.packStatus = this.$route.query.packStatus
    this.trackingNumber = this.$route.query.tailTrackingCode
    this.show()
  },
  methods: {
    show() {
      const params = {
        package_number: [this.omsPackId],
        track_number: [this.trackingNumber]
      }
      API.orderLogisticsTrackInfo(params).then(res => {
        this.trackingTimeLine = res.data
        this.trackingNumberVisible = true
        // this.setSolidLineHeight()
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },
    trackingNumberClose() {
      this.trackingNumberInfo = {}
      this.trackingTimeLine = []
      this.trackingNumberVisible = false
    },
    setSolidLineHeight() {
      this.$nextTick(() => {
        // 每行连接实线基础高为36px，每多一行加22px
        const eleArr = document.querySelectorAll('.timeline_item');
        [...eleArr].forEach(e => {
          const clientHeight = e.children[2].clientHeight
          const dotEle = e.children[1]
          let descriptionLine = (clientHeight / 22)
          dotEle.children[0].style.height = `${36 + (descriptionLine - 1) * 22}px`
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.containBox{
  min-height: calc(100vh - 43px) !important;
}
.content{
  margin-bottom: 30px;
  >p{
    font-size: 14px;
    margin-bottom: 10px;
  }
  .packStatus{
    margin-left: 90px;
  }
  .timeline {
    .timeline_item{
      margin-bottom: 24px;
      .time{
        font-size: 14px;
        line-height: 22px;
      }
      .dot{
        margin: 5px 8px 0 10px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #F5F7F7;
        border: 1px solid #CDD4DD;
        .solidLine {
          width: 2px;
          background-color: #CDD4DD;
          position: absolute;
          top: 10px;
          left: 4px;
          right: 0;
        }
      }
      .description {
        font-size: 14px;
        line-height: 22px;
        width: 350px;
      }
      .active{
        color: #99C41C;
      }
      .dot_active{
        background-color: #99C41C;
        border-color: #99C41C;
      }
    }
    .timeline_item:last-of-type{
      .dot{
        .solidLine{
          display: none;
        }
      }
    }

  }
  .timeline_line_123123123123213213{
    /deep/.el-timeline-item__node--primary + .el-timeline-item__wrapper{
        /deep/.el-timeline-item__timestamp{
            color: #99C41C;
        }
    }
  }
  .packStatus{
    font-size: 14px;
    margin-bottom: 20px;
  }
  .packStatus::before{
        content: '';
        display: block;
        margin-right: 4px;
        width: 8px;
        height: 8px;
        line-height: 28px;
        border-radius: 100%;
  }
  .red{
        color: #E53353;
  }
  .red::before{
        background-color: #E53353;
  }
  .green{
    color: #99C41C;
  }
  .green::before{
    background-color: #99C41C;
  }
}
</style>
<style lang="scss">
.timeline_line_123123123123213213{
    .el-timeline-item__node--primary + .el-timeline-item__wrapper{
        .el-timeline-item__timestamp{
            color: #99C41C;
            font-size: 14px;
        }
    }
}
</style>
